var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"share",on:{"click":_vm.close}},[_c('img',{attrs:{"src":"https://picbed.qunarzz.com/60da80e3f4a84db2d02cb351687fb2ae.png","alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }